import { IUTMPayload } from "../Services/UTMService";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export const hasUTMParams = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return UTM_KEYS.some((key) => !!params.get(key));
};

export const buildUTMPayload = (search: string): IUTMPayload => {
  const params = new URLSearchParams(search);
  const now = new Date().toISOString();

  if (!localStorage.getItem("utm_first_visit")) {
    localStorage.setItem("utm_first_visit", now);
  }

  return {
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
    utm_term: params.get("utm_term") || undefined,
    utm_content: params.get("utm_content") || undefined,
    landing_page: window.location.pathname,
    landing_url: window.location.href,
    referrer: document.referrer || undefined,
    first_visit: localStorage.getItem("utm_first_visit") ?? now,
    last_visit: now,
  };
};

export const stripUTMFromSearch = (search: string): string => {
  const params = new URLSearchParams(search);
  UTM_KEYS.forEach((key) => params.delete(key));
  const cleaned = params.toString();
  return cleaned ? `?${cleaned}` : "";
};
